module.exports = __webpack_public_path__ + "img/label-operateur-autorise.e7084969.png";